document.addEventListener('DOMContentLoaded', function () {
    let currentStep = 1;

    function showStep(step) {
        const steps = document.querySelectorAll('.step');
        if (steps.length > 0) {
            steps.forEach((el) => {
                el.style.display = el.dataset.step == step ? 'block' : 'none';
            });
        }

        const progressSpans = document.querySelectorAll('.Steps span');
        if (progressSpans.length > 0) {
            progressSpans.forEach((el) => {
                el.classList.remove('active');
            });

            const currentStepSpan = document.querySelector(`.Steps .step-${step}`);
            if (currentStepSpan) {
                currentStepSpan.classList.add('active');
            }
        }
    }

    function scrollToForm() {
        const form = document.getElementById('configurator-form');
        if (form) {
            form.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    function nextStep() {
        if (validateStep(currentStep)) {
            currentStep++;
            showStep(currentStep);
            scrollToForm();
        }
    }

    function prevStep() {
        currentStep--;
        showStep(currentStep);
        scrollToForm();
    }

    function validateStep(step) {
        const stepEl = document.querySelector(`.step[data-step="${step}"]`);
        if (!stepEl) return true;

        const inputs = stepEl.querySelectorAll('input, textarea');
        for (let input of inputs) {
            if (!input.checkValidity()) {
                alert('Uzupełnij wszystkie pola.');
                return false;
            }
        }
        return true;
    }

    const form = document.getElementById('configurator-form');
    if (form) {
        form.addEventListener('submit', function (e) {
            e.preventDefault();

            const formData = new FormData(this);

            fetch('/wp-content/themes/starter/send-config.php', {
                method: 'POST',
                body: formData,
            })
                .then((res) => res.text())
                .then((response) => {
                    if (response === 'success') {
                        window.location.href = '/potwierdzenie-zgloszenia/';
                    } else {
                        alert('Wystąpił problem z wysłaniem formularza. Przepraszamy');
                    }
                })
                .catch((err) => {
                    alert('Błąd podczas wysyłania.');
                    console.error(err);
                });
        });
    }

    showStep(currentStep);

    const nextButtons = document.querySelectorAll('.nextStep');
    if (nextButtons.length > 0) {
        nextButtons.forEach((btn) => {
            btn.addEventListener('click', nextStep);
        });
    }

    const prevButtons = document.querySelectorAll('.prevStep');
    if (prevButtons.length > 0) {
        prevButtons.forEach((btn) => {
            btn.addEventListener('click', prevStep);
        });
    }
});


document.addEventListener('DOMContentLoaded', function () {
    const wrappers = document.querySelectorAll('.ButtonsWrapper');
    if (wrappers.length > 0) {
        wrappers.forEach(function (wrapper) {
            const buttons = wrapper.querySelectorAll('button');
            if (buttons.length === 1) {
                wrapper.style.justifyContent = 'center';
            } else if (buttons.length > 1) {
                wrapper.style.justifyContent = 'space-between';
            }
        });
    }
});
